import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Image = ({src, width, height, borderRadius, style, onClick}) => {
    return (
        <div style={{
            overflow:'hidden',
            width: width,
            height: height,
            borderRadius: borderRadius,
            maxWidth:'100%',
            ...style
        }}>
            <LazyLoadImage
                alt={''}
                src={src}
                width={width}
                height={height}
                style={style}
                onClick={onClick}
                effect="blur"
            />
        </div>
    );
}

export default Image;